var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6713 8.36824H18V8.33366H10.5V11.667H15.2096C14.5225 13.6074 12.6763 15.0003 10.5 15.0003C7.73877 15.0003 5.50002 12.7616 5.50002 10.0003C5.50002 7.23908 7.73877 5.00033 10.5 5.00033C11.7746 5.00033 12.9342 5.48116 13.8171 6.26658L16.1742 3.90949C14.6859 2.52241 12.695 1.66699 10.5 1.66699C5.89794 1.66699 2.16669 5.39824 2.16669 10.0003C2.16669 14.6024 5.89794 18.3337 10.5 18.3337C15.1021 18.3337 18.8334 14.6024 18.8334 10.0003C18.8334 9.44158 18.7759 8.89616 18.6713 8.36824Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1283 6.12157L5.86621 8.12949C6.60705 6.29533 8.40121 5.00033 10.5008 5.00033C11.7754 5.00033 12.935 5.48116 13.8179 6.26657L16.175 3.90949C14.6866 2.52241 12.6958 1.66699 10.5008 1.66699C7.29996 1.66699 4.52413 3.47408 3.1283 6.12157Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4998 18.3326C12.6523 18.3326 14.6081 17.5089 16.0869 16.1693L13.5077 13.9868C12.6429 14.6445 11.5862 15.0002 10.4998 14.9993C8.3323 14.9993 6.49189 13.6172 5.79855 11.6885L3.08105 13.7822C4.46022 16.481 7.26105 18.3326 10.4998 18.3326Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6713 8.36759H18V8.33301H10.5V11.6663H15.2096C14.8809 12.5898 14.2889 13.3968 13.5067 13.9876L13.5079 13.9868L16.0871 16.1693C15.9046 16.3351 18.8333 14.1663 18.8333 9.99967C18.8333 9.44092 18.7758 8.89551 18.6713 8.36759Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ab1d20892c0a5daa90b9a7beca7014df.svg";
export { ForwardRef as ReactComponent };